import { COST_CENTERS } from "..";
import { apiInstance } from "../config/apiInstance";

export type PutCostCenterRequest = {
  name: string;
  description: string;
  accountingAccount: string;
  conceptCode: string;
  fundingSource: string;
  stateId: number;
  effectiveStartDate: string;
  effectiveEndDate: string;
};

export type PutCostCenterState = {
  id: number;
  code: string;
  name: string;
};

export type PutCostCenterHealthServiceProvider = {
  id: number;
  code: string;
  employerIdNumber: string;
  name: string;
  creditor: string;
};

export type PutCostCenterResponse = {
  id: number;
  code: string;
  name: string;
  description: string;
  accountingAccount: string;
  conceptCode: string;
  fundingSource: string;
  state: PutCostCenterState;
  effectiveStartDate: string;
  effectiveEndDate: string;
};

export const putCostCenter = async (
  id: number,
  data: PutCostCenterRequest,
): Promise<PutCostCenterResponse> => {
  const response = await apiInstance.put<PutCostCenterResponse>(
    `${COST_CENTERS}/${id}`,
    data,
  );
  return response.data;
};
